import { nanoid } from '@reduxjs/toolkit';

// Who this browser is. `userId` is shown to everyone in a game; `playerKey`
// never leaves this browser except to prove to the server that a seat is
// ours (the server keeps only a hash of it). Without the key, knowing a
// player's userId would be enough to see their hand or join a call as them.

const read = (name) => {
    try {
        return localStorage.getItem(name);
    } catch (error) {
        return null;
    }
};

const ensure = (name, size) => {
    let value = read(name);
    if (!value) {
        value = nanoid(size);
        try {
            localStorage.setItem(name, value);
        } catch (error) { /* private mode: this tab keeps it in memory */ }
    }
    return value;
};

let userId;
let playerKey;

export const getUserId = () => {
    userId = userId || ensure('userId', 21);
    return userId;
};

export const getPlayerKey = () => {
    playerKey = playerKey || ensure('playerKey', 32);
    return playerKey;
};
